import $ from  'jquery'
import { getToken } from '@/utils/auth'
const dictionaryData={};
const regionsData={}
const configData={}
const SITE = process.env.VUE_APP_SITE||''
const  cache={

  getDic(dicKey){
    if(dictionaryData["dic_"+dicKey]){
      return dictionaryData["dic_"+dicKey];
    }else{

      $.ajax({
        headers: {
          token:  getToken()
        },
        url:SITE+ "/api/property/getDictionaryCache/"+dicKey,
        async: false,
        success: function(data){
          if(data){
            dictionaryData["dic_"+dicKey]=data;
          }
        }
      });
      return dictionaryData["dic_"+dicKey];
    }
  },
  getCascaderDic(dicKey){
    if(dictionaryData["cascader_dic_"+dicKey]){
      return dictionaryData["cascader_dic_"+dicKey];
    }else{

      $.ajax({
        headers: {
          token:  getToken()
        },
        url: SITE+"/api/category/getCategoryDetail/"+dicKey,
        async: false,
        success: function(data){
          if(data){
            dictionaryData["cascader_dic_"+dicKey]=data;
          }
        }
      });
      return dictionaryData["cascader_dic_"+dicKey];
    }
  },
  getRegion(code){
    if(regionsData["region_"+code]){
      return regionsData["region_"+code];
    }else{

      $.ajax({
        headers: {
          token:  getToken()
        },
        url: SITE+"/api/region/"+code,
        async: false,
        success: function(data){
          if(data){
            regionsData["region_"+code]=data;
          }
        }
      });
      return regionsData["region_"+code];
    }
  },
  getConfig(code){
    if(configData["config_"+code]){
      return configData["config_"+code].value;
    }else{

      $.ajax({
        headers: {
          token:  getToken()
        },
        url:SITE+  "/api/config/queryConfig/"+code,
        async: false,
        success: function(data){
          if(data){
            configData["config_"+code]=data;
          }
        }
      });
      return configData["config_"+code].value;
    }
  }
}

export default cache
